import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Collections } from './pages/Collections';
import { PropertyDetail } from './pages/PropertyDetail';
import { KochiGuide } from './pages/KochiGuide';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-[#2C2C2C]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/collections" element={<Collections data-id="element-7" />} data-id="element-6" />
          <Route path="/property/:id" element={<PropertyDetail data-id="element-9" />} data-id="element-8" />
          <Route path="/kochi-guide" element={<KochiGuide data-id="element-11" />} data-id="element-10" />
        </Routes>
      </main>
      <Footer data-id="element-12" />
    </div>;
}